import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { DiscussionService } from 'src/app/shared-service/services/discussion.service';
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import { IntersectionStatus } from '../../directives/from-intersection-observer';
//TimeAgo.addDefaultLocale(en)

@Component({
  selector: 'app-story-view-list-popup',
  templateUrl: './story-view-list-popup.component.html',
  styleUrls: ['./story-view-list-popup.component.css']
})
export class StoryViewListPopupComponent implements OnInit {
  viewList=[];
  pageIndex=0;
  storyId='';
  storyViewedIdArray =[];
  scrollDisable=false;
  showListLoader=false;
  intersectionStatus = IntersectionStatus;
  colorPallete = ['green','pink','orange','red','blue', 'gold', 'yelow','violet','silver'];

  public onHide: Subject<any> = new Subject<any>();
  constructor(  public bsModalRef: BsModalRef,
    private discussionService: DiscussionService,) { }

  ngOnInit(): void {
    this.getStoriesViewedList()
  }

  onVisibilityChanged(index: number, status: IntersectionStatus) {
    // this.visibilityStatus[index] = status;
     if(status == 'Visible') {
       this.getStoriesViewedList();
     }
   }


  getStoriesViewedList() {
    this.discussionService.getMyStoriesViews(this.storyId, this.pageIndex).subscribe(
      (res:any) => {
        if(res && res.data) {
         // this.stories = [...this.stories,...res.data];
          this.processStoryClick(res.data);
          this.pageIndex++;
          this.showListLoader=false;
          if(!this.scrollDisable) {
            setTimeout(()=> {
              this.showListLoader=true;
            }, 500);
          }
        } else {
          this.showListLoader=false;
          this.scrollDisable = true;
        }
      }
    );
  }

  processStoryClick(newData) {
    var me =this;
    const timeAgo = new TimeAgo('en-US');
    newData.forEach(item => {
      //item.user_id
     // if(me.storyViewedIdArray.indexOf(item.user_id) == -1) {
        var timeDiff = Date.now().valueOf() - new Date(item.date).valueOf();
        item.date = timeAgo.format(Date.now() - timeDiff, 'round');
        if(item.user_image && item.user_image.indexOf('dummy-profile') == -1) {
          item.user_image = item.user_image;
        } else if(item.name) {
          item.customProfileName = item.name.charAt(0).toUpperCase()
        } else {
          item.customProfileName = 'G';
        }
        item.colorPick = me.colorPallete[Math.floor(Math.random() * 9)]
       // me.storyViewedIdArray.push(item.user_id);
        me.viewList.push(item);
      //}
    });
  }


  closeModal(){
    this.onHide.next('true');
    this.bsModalRef.hide();
  }

}
